import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['payment', 'payee', 'lenderEmails', 'brokerEmails', 'applicantEmail'];
  static values = { currentPaymentMethod: String, paymentMethods: Object, payeePaymentMethods: Object };

  initialize() {
    this.payeeChosen();
  }

  payeeChosen(_e) {
    const payee = this.payeeTarget.value;
    this.toggleEmails(payee);
    this.updatePaymentMethods(payee);
    this.updateApplicantEmailInput(payee);
  }

  toggleEmails (payee) {
    const lenderEmails = this.lenderEmailsTarget;
    const brokerEmails = this.brokerEmailsTarget;

    if (payee === 'lender') {
      lenderEmails.style.display = 'block';
      brokerEmails.style.display = 'none';
    } 
    else if (payee === 'broker') {
      lenderEmails.style.display = 'none';
      brokerEmails.style.display = 'block';
    }
    else {
      lenderEmails.style.display = 'none';
      brokerEmails.style.display = 'none';
    }
  }

  updatePaymentMethods(payee) {
    const component = this.paymentTarget.closest('div[data-controller="single-select-field"]');
    const paymentTargetController = this.application.getControllerForElementAndIdentifier(component, 'single-select-field');
    
    const paymentMethods = this.payeePaymentMethodsValue;
    const availablePaymentMethods = paymentMethods[payee] || [];
    
    const paymentMenu = document.getElementById('quote_valuation_attributes_payment_method_menu');
    const paymentOptions = paymentMenu.querySelectorAll('li[data-value]');
    const selectedValue = this.paymentTarget.value;
    
    paymentOptions.forEach(option => {
      const optionValue = option.querySelector('input').value;

      if (availablePaymentMethods.includes(optionValue)) {
        option.style.pointerEvents = 'auto';
        option.querySelector('label').style.display = 'flex';
        option.setAttribute('data-action', 'click->single-select-field#selectFromItem');
      } else {
        option.style.pointerEvents = 'none';
        option.querySelector('label').style.display = 'none';
        option.removeAttribute('data-action');

        if (paymentTargetController && selectedValue == optionValue) {
          paymentTargetController.clearSelection();
        }
      }
    });

    if (paymentTargetController && payee === 'applicant' && this.currentPaymentMethodValue !== 'card') {
      const value = 'bacs';
      paymentTargetController.setValue(value);
    }
  }

  // If applicant is chosen as payee, then we want the input
  // to be required to proceed with a selected quote,
  // otherwise - make it optional
  updateApplicantEmailInput(payee) {
    const component = this.applicantEmailTarget.parentElement.parentElement;
    const inputController = this.application.getControllerForElementAndIdentifier(component, 'input');

    if (inputController) {
      const required = payee === 'applicant';
      inputController.setRequired(required);
    }
  }
}
